import { render, staticRenderFns } from "./OrderApprovalModal.vue?vue&type=template&id=c55fe634&"
import script from "./OrderApprovalModal.vue?vue&type=script&lang=js&"
export * from "./OrderApprovalModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports